(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["movd-faq"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-faq-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.movd-faq__item');
        var answer = item.querySelector('[data-faq-answer]');
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        btn.querySelector('.movd-faq__sign').textContent = open ? '+' : '–';
        answer.hidden = open;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movd-quiz"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.movd-quiz').forEach(function (root) {
      var answers = {};
      var form = root.querySelector('[data-quiz-form]');
      var result = root.querySelector('[data-quiz-result]');
      var errorEl = root.querySelector('[data-quiz-error]');

      root.querySelectorAll('.movd-quiz__question').forEach(function (q) {
        var key = q.getAttribute('data-question');
        q.querySelectorAll('.movd-quiz__option').forEach(function (opt) {
          opt.addEventListener('click', function () {
            answers[key] = opt.getAttribute('data-value');
            q.querySelectorAll('.movd-quiz__option').forEach(function (o) { o.classList.remove('is-active'); });
            opt.classList.add('is-active');
            errorEl.hidden = true;
          });
        });
      });

      function quizResult(a) {
        var solo = a.lidi === 'Sám / sama';
        var many = a.lidi === 'Tři a víc';
        var empty = a.vybaveni === 'Nemám nic';
        var most = a.vybaveni === 'Většinu mám';
        var title = 'Box pokryje první dva dny, zbytek dořešíš postupně';
        if (empty) title = 'Začínáš od nuly — box pokryje celý první večer';
        else if (most) title = 'Základ máš, box ti pokryje to, co zůstane zabalené';
        var parts = [];
        parts.push(a.typ === 'První vlastní bydlení'
          ? 'U prvního bydlení chybí nejčastěji drobnosti, na které se nemyslí: toaletní papír, mýdlo, hadr a něco na rozřezání pásky. Tyhle věci v boxu jsou.'
          : a.typ === 'Stěhujeme se spolu'
            ? 'Když se stěhujete spolu, nakupují se stejné věci dvakrát. Box vám nahradí jednu sadu drobností a ušetří dvojí objednávku.'
            : 'U dalšího stěhování je problém spíš čas než seznam. Box ti ubere jednu položku z programu dne — nákup drobností.');
        if (empty) parts.push('Protože nemáš nic, využiješ hlavně úklid, koupelnu a nástroje na rozbalování. Kuchyňský základ budeš chtít doplnit podle toho, jak vaříš.');
        else if (most) parts.push('Většinu věcí máš, takže z boxu oceníš spíš nástroje, LED světlo a věci na první večer než další čistič.');
        else parts.push('Něco už máš, ale v den stěhování bývá zabalené přesně to, co zrovna potřebuješ. Box je tvoje záloha po ruce.');
        if (many) parts.push('Pro tři a víc lidí počítej s tím, že spotřební věci vydrží kratší dobu — box řeší první dva dny, ne celý týden.');
        else if (solo) parts.push('Sám / sama zvládneš první dva dny z jednoho boxu bez doplňování.');
        return { title: title, body: parts.join(' '), tags: [a.typ, a.lidi, a.vybaveni].filter(Boolean) };
      }

      root.querySelector('[data-quiz-submit]').addEventListener('click', function () {
        if (!answers.typ || !answers.lidi || !answers.vybaveni) { errorEl.hidden = false; return; }
        var r = quizResult(answers);
        root.querySelector('[data-result-title]').textContent = r.title;
        root.querySelector('[data-result-body]').textContent = r.body;
        var tagsEl = root.querySelector('[data-result-tags]');
        tagsEl.innerHTML = '';
        r.tags.forEach(function (t) {
          var span = document.createElement('span');
          span.textContent = t;
          tagsEl.appendChild(span);
        });
        form.hidden = true;
        result.hidden = false;
      });

      root.querySelector('[data-quiz-reset]').addEventListener('click', function () {
        answers = {};
        root.querySelectorAll('.movd-quiz__option').forEach(function (o) { o.classList.remove('is-active'); });
        errorEl.hidden = true;
        result.hidden = true;
        form.hidden = false;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movd-unboxing"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.movd-unboxing').forEach(function (track) {
      var steps = track.querySelectorAll('.movd-unboxing__step');
      var ticking = false;
      function update() {
        ticking = false;
        var r = track.getBoundingClientRect();
        var vh = window.innerHeight || 800;
        var p;
        if (r.height > vh * 1.4) {
          p = Math.max(0, Math.min(1, -r.top / Math.max(1, r.height - vh)));
        } else {
          p = Math.max(0, Math.min(1, (vh - r.top - vh * 0.25) / (r.height + vh * 0.35)));
        }
        steps.forEach(function (el, i) {
          var on = reduce || p > 0.16 + i * 0.13;
          el.classList.toggle('is-on', on);
        });
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      update();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["movd-whats-inside"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.movd-inside').forEach(function (root) {
      var filters = root.querySelectorAll('.movd-inside__filter');
      var hotspots = root.querySelectorAll('.movd-inside__hotspot');
      var panelName = root.querySelector('[data-panel-name]');
      var panelWhy = root.querySelector('[data-panel-why]');

      function selectItem(btn) {
        hotspots.forEach(function (h) { h.classList.toggle('is-active', h === btn); });
        if (!btn) return;
        panelName.textContent = btn.getAttribute('data-name');
        panelWhy.textContent = btn.getAttribute('data-why');
      }

      function applyFilter(label) {
        hotspots.forEach(function (h) {
          var cats = h.getAttribute('data-cats').split(',');
          var match = label === 'Vše' || cats.indexOf(label) > -1;
          h.classList.toggle('is-dim', !match);
        });
        var activeStillVisible = root.querySelector('.movd-inside__hotspot.is-active:not(.is-dim)');
        if (!activeStillVisible) {
          var first = null;
          hotspots.forEach(function (h) { if (!first && !h.classList.contains('is-dim')) first = h; });
          if (first) selectItem(first);
        }
      }

      filters.forEach(function (f) {
        f.addEventListener('click', function () {
          filters.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
          f.classList.add('is-active');
          f.setAttribute('aria-pressed', 'true');
          applyFilter(f.getAttribute('data-filter'));
        });
      });

      hotspots.forEach(function (h) {
        h.addEventListener('click', function () { selectItem(h); });
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
